module.exports = "<template class=\"p-2\">\r\n    <div class=\"spinner-wheel\"></div>\r\n</template>";